import React, { useState, useEffect, useRef, useContext } from "react";
import {
  addGuest,
  calculateAge,
  calculatePayableAmount,
  calculateStayDuration,
  extractData,
  getCredit,
  getCurrentLocalDateTime,
  getEditGuest,
  getRoom,
  updateGuest,
} from "../utils/helperFunctions";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import { Mycontext } from "../context/context";
import PDFContent from "./PDFContent";
import { format, isAfter } from "date-fns";
import MobileNumberDropdown from "./MobileNumberDropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { subYears } from "date-fns";
import FullScreenSignatureModal from "./FullScreenSignatureModal";
import NamesearchDropdown from "./NamesearchDropdown";

const GuestAndCheckInForm = ({
  action,
  editvalue,
  isEdit,
  selectedRoomId,
  setEditvalue,
  role,
  setisEdit,
}) => {
  const initialFormState = {
    firstName: "",
    middleName: "",
    lastName: "",
    companyName: "",
    mobileNumber: "",
    address: {
      address: "",
      houseFlatNo: "",
      locality: "",
      city: "SURAT",
      district: "SURAT",
      zipCode: "",
      country: "India",
      state: "Gujarat",
    },
    dateOfBirth: "",
    phoneNumber: "",
    emailAddress: "",
    comingFrom: "SURAT",
    goingTo: "SURAT",
    roomNumber: "",
    checkInDate: "",
    checkInTime: "",
    checkOutDate: "",
    checkOutTime: "",
    numberOfAdults: 2,
    numberOfChildren: 0,
    advancePayAmount: 0,
    vehicleType: "",
    vehicleRegistrationNo: "",
    documentNumber: "",
    documentType: "",
    signature: null,
    documentUrl: [],
    otherGuests: [
      {
        fullName: "",
        mobileNumber: "",
        documentType: "",
        documentNumber: "",
        dateOfBirth: "",
        documentUrl: [],
        address: "",
        signature: null,
        isLoading: false
      },
    ],
    nightCheckInConfirmed: false,
    expectedCheckoutHour: 1,
    noPathikEntry: false,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [isLoading, setIsLoading] = useState(false);
  const [isextract, setISextract] = useState(false);

  const [suggestions, setSuggestions] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const [namesuggestions, setnameSuggestions] = useState([]);
  const [namequery, setnameQuery] = useState("");
  const [nameloading, setnameLoading] = useState(false);

  const [roomData, setRoomData] = useState([]);
  const [showFullScreenSign, setShowFullScreenSign] = useState(false);
  const [activeGuestIndex, setActiveGuestIndex] = useState(null);
  const fullScreenSigCanvas = useRef(null);
  const [filePreviews, setFilePreviews] = useState([]);

  const [fileerr, setfileerr] = useState("");
  const [signErr, setsignErr] = useState("");
  const [errMsg, setErrmsg] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [guestFileErrors, setGuestFileErrors] = useState([]);

  const [guestPreviewUrls, setGuestPreviewUrls] = useState([]);
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showSubmitConfirmModal, setShowSubmitConfirmModal] = useState(false);
  const [billdetails, setbilldetails] = useState({
    stayHours: "",
    payableHours: "",
    payableAmount: "",
    paymentMethod: "not selected",
    paidAmount: 0,
    notes: "",
    returnAmount: 0,
  });

  // const [extrectData,setextrectData ] = useState({})
  const { setFormToShow, formToShow, setCreditToupdate } = useContext(Mycontext);
  const [searchParams] = useSearchParams();
  const initialPage = parseInt(searchParams.get("page")) || 1;
  const { dateTime } = getCurrentLocalDateTime();
  // console.log("isEdit",isEdit);
  // console.log("editvalue",editvalue);


  // console.log("query",query);
  // console.log("isLoading", isLoading);
  // console.log("formData", formData);
  // console.log("showSubmitConfirmModal", showSubmitConfirmModal);

  const handleStartSignature = async (index = null) => {
    setActiveGuestIndex(index);
    setShowFullScreenSign(true);
    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (index !== null) {
        delete newErrors[`otherGuest_signature_${index}`];
      } else {
        delete newErrors.signature;
      }
      return newErrors;
    });
    setTimeout(async () => {
      if (fullScreenSigCanvas.current) {
        fullScreenSigCanvas.current.clear();
      }

      const canvasWrapper = document.getElementById("signature-wrapper");
      if (canvasWrapper?.requestFullscreen) {
        try {
          await canvasWrapper.requestFullscreen();
        } catch (err) {
          console.error("Fullscreen error:", err);
        }
      }
    }, 100);
  };

  const handleFullScreenSave = () => {
    if (fullScreenSigCanvas.current) {
      const isEmpty = fullScreenSigCanvas.current.isEmpty?.();

      if (isEmpty) {
        setsignErr("Please Provide Signature");
        return;
      }
      const signature = fullScreenSigCanvas.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      if (activeGuestIndex !== null) {
        const updatedGuests = [...formData.otherGuests];
        updatedGuests[activeGuestIndex].signature = signature;
        setFormData((prev) => ({ ...prev, otherGuests: updatedGuests }));
      } else {
        setFormData((prev) => ({ ...prev, signature }));
      }
      setActiveGuestIndex(null);
      setShowFullScreenSign(false);
    }
  };

  const handleNextSignature = () => {
    if (fullScreenSigCanvas.current && !fullScreenSigCanvas.current.isEmpty()) {
      handleFullScreenSave();
      const nextIndex = findNextGuestNeedingSignature();
      if (nextIndex !== null) {
        handleStartSignature(nextIndex);
      } else {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        setShowFullScreenSign(false);
      }
    }
  };

  const handlePreviousSignature = () => {
    if (fullScreenSigCanvas.current && !fullScreenSigCanvas.current.isEmpty()) {
      handleFullScreenSave();
      const prevIndex = findPreviousGuestNeedingSignature();
      if (prevIndex !== null) {
        handleStartSignature(prevIndex);
      } else if (
        prevIndex === null &&
        activeGuestIndex !== null &&
        !formData.signature
      ) {
        handleStartSignature(null);
      } else {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        setShowFullScreenSign(false);
      }
    }
  };

  const findNextGuestNeedingSignature = () => {
    if (activeGuestIndex === null) {
      const firstGuestNeedingSignature = formData.otherGuests.findIndex(
        (guest) => !guest.signature
      );
      return firstGuestNeedingSignature !== -1
        ? firstGuestNeedingSignature
        : null;
    }
    for (let i = activeGuestIndex + 1; i < formData.otherGuests.length; i++) {
      if (!formData.otherGuests[i].signature) {
        return i;
      }
    }

    return null;
  };

  const findPreviousGuestNeedingSignature = () => {
    if (activeGuestIndex === null) {
      return null;
    }
    for (let i = activeGuestIndex - 1; i >= 0; i--) {
      if (!formData.otherGuests[i].signature) {
        return i;
      }
    }
    if (!formData.signature) {
      return null;
    }
    return null;
  };

  useEffect(() => {
    fetchRooms();
    const { date, time, dateTime } = getCurrentLocalDateTime();
    setFormData({
      ...initialFormState,
      roomNumber: selectedRoomId || "",
      checkInDate: date,
      checkInTime: time,
    });
  }, []);

  useEffect(() => {
    if (
      (formData.roomNumber &&
        formData.checkOutDate &&
        formData.checkOutTime &&
        !isEdit) ||
      (isEdit &&
        formData.checkOutDate &&
        formData.checkOutTime &&
        (editvalue.checkInDate !== formData.checkInDate ||
          editvalue.checkOutDate !== formData.checkOutDate ||
          editvalue.checkInTime !== formData.checkInTime ||
          editvalue.checkOutTime !== formData.checkOutTime))
    ) {
      const checkInDateObj = new Date(
        `${formData.checkInDate}T${formData.checkInTime}`
      );
      const checkOutDateObj = new Date(
        `${formData.checkOutDate}T${formData.checkOutTime}`
      );

      const stayHours = calculateStayDuration(checkInDateObj, checkOutDateObj);
      const roomDetails = roomData.find(
        (room) => room._id === formData.roomNumber
      );
      const { payableHours, payableAmount } = calculatePayableAmount(
        stayHours,
        roomDetails?.gracePeriod,
        roomDetails?.hourlyPricing,
        checkInDateObj,
        checkOutDateObj,
        formData?.nightCheckInConfirmed,
        roomDetails?.nightStayPrice
      );
      const remainingAmount = payableAmount - formData.advancePayAmount;
      setbilldetails((pre) => ({
        ...pre,
        stayHours,
        payableHours,
        payableAmount,
        paidAmount: remainingAmount > 0 ? remainingAmount : 0,
        returnAmount: remainingAmount < 0 ? Math.abs(remainingAmount) : 0,
      }));
    }
  }, [formData]);

  const fetchRooms = async () => {
    try {
      const response = await getRoom();

      if (response.status) {
        setRoomData(response.data);
      }
    } catch (error) {
      console.error("Error fetching rooms:", error);
    }
  };

  function shouldShowCheckboxFn() {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    const editDate = new Date(
      `${formData.checkInDate} ${formData.checkInTime}`
    );
    const editHour = editDate.getHours();
    const editMinute = editDate.getMinutes();

    const result =
      (!isEdit && currentHour >= 19) ||
      (!isEdit && currentHour < 5) ||
      (!isEdit && currentHour === 5 && currentMinute === 0) ||
      (isEdit && editHour >= 19) ||
      (isEdit && editHour < 5) ||
      (isEdit && editHour === 5 && editMinute === 0);
    return result;
  }
  const selectedRoom = formData.roomNumber
    ? roomData.find((room) => room._id === formData.roomNumber)
    : null;

  useEffect(() => {
    if (editvalue && isEdit) {
      setFormData({
        ...editvalue.guestId,
        address: {
          ...editvalue.guestId.address,
          country: "India",
        },
        ...editvalue,
        guestId: editvalue.guestId._id,
        checkInId: editvalue._id,
        checkInDate: editvalue?.checkInDate
          ? editvalue?.checkInDate?.split("T")[0]
          : "",
        checkOutDate: editvalue?.checkOutDate
          ? editvalue?.checkOutDate?.split("T")[0]
          : "",
        numberOfChildren: editvalue?.numberOfChildren ?? 0,
        advancePayAmount: editvalue?.advancePayAmount ?? 0,
        expectedCheckoutHour: editvalue?.expectedCheckoutHour ?? 1,
        noPathikEntry: editvalue?.noPathikEntry
          ? editvalue?.noPathikEntry
          : false,
        dateOfBirth: editvalue.guestId?.dateOfBirth
          ? editvalue.guestId?.dateOfBirth?.split("T")[0]
          : "",
        age: editvalue.guestId?.dateOfBirth
          ? calculateAge(editvalue.guestId?.dateOfBirth?.split("T")[0])
          : null,
      });
    }
  }, [editvalue, isEdit]);

  useEffect(() => {
    const checkCanvasEmpty = () => {
      return fullScreenSigCanvas.current?.isEmpty?.() ?? true;
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();

        if (showSubmitConfirmModal) {
          setShowSubmitConfirmModal(false);
        } else if (formToShow === "formA" && showCancelModal) {
          setShowCancelModal(false);
        } else if (formToShow === "formA" && showPdfPreview) {
          setShowPdfPreview(false);
        } else if (
          formToShow === "formA" &&
          !showCancelModal &&
          !showPdfPreview
        ) {
          setShowCancelModal(true);
        } else if (document.fullscreenElement) {
          document.exitFullscreen();
          setShowFullScreenSign(false);
        }
      } else if (event.key === "Enter" && role !== "view only") {
        if (showFullScreenSign) {
          event.preventDefault();
          handleFullScreenSave();
        } else if (
          !showFullScreenSign &&
          !showCancelModal &&
          !showPdfPreview &&
          !isModalOpen &&
          !showSubmitConfirmModal &&
          !event.target.matches("textarea, input[type='file'], select")
        ) {
          event.preventDefault();
          setShowSubmitConfirmModal(true);
        } else if (showSubmitConfirmModal && !isLoading) {
          setIsLoading(true);
          handleSubmit();
        }
      } else if (event.key === "ArrowRight" && showFullScreenSign) {
        event.preventDefault();
        handleNextSignature();
      } else if (event.key === "ArrowLeft" && showFullScreenSign) {
        event.preventDefault();
        handlePreviousSignature();
      }
    };

    const handleFullscreenChange = () => {
      if (!document.fullscreenElement && showFullScreenSign) {
        if (!checkCanvasEmpty()) {
          handleFullScreenSave();
        }
        setShowFullScreenSign(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [
    formToShow,
    showCancelModal,
    showPdfPreview,
    showSubmitConfirmModal,
    showFullScreenSign,
    isModalOpen,
    activeGuestIndex,
    isLoading,
  ]);

  const handleSuggestionClick = async (guest) => {
    if (editvalue?.checkOutDate) return;
    const { date, time } = getCurrentLocalDateTime();
    const response = await getEditGuest(
      guest.checkInId,
      guest.guestId,
      guest.otherGuestsKey
    );
    if (response.data.status) {
      setFormErrors({});
      setErrmsg("");
      setfileerr("");
      const guestData = response.data.data;

      setFormData((pre) => ({
        ...pre,
        ...guestData,
        checkInId: isEdit ? editvalue._id : guestData._id || "",
        guestId: isEdit
          ? editvalue?.guestId?._id || ""
          : guestData?.guestId?._id || "",
        ...guestData.guestId,
        address: {
          ...guestData.guestId.address,
          city: guestData.guestId.address.city
            ? guestData.guestId.address.city
            : "SURAT",
          district: guestData.guestId.address.district
            ? guestData.guestId.address.district
            : "SURAT",
          state: guestData.guestId.address.state
            ? guestData.guestId.address.state
            : "Gujarat",
          country: "India",
        },
        emailAddress: guestData.emailAddress
          ? guestData.emailAddress
          : `${guestData.guestId.firstName}@GMAIL.COM`,
        checkInDate: isEdit
          ? editvalue?.checkInDate?.split("T")[0] || ""
          : date,
        checkInTime: isEdit ? editvalue?.checkInTime || "" : time,
        comingFrom: guestData.comingFrom ? guestData.comingFrom : "SURAT",
        goingTo: guestData.goingTo ? guestData.goingTo : "SURAT",
        dateOfBirth: guestData.guestId?.dateOfBirth
          ? guestData.guestId?.dateOfBirth?.split("T")[0]
          : "",
        numberOfAdults:
          !guestData.numberOfAdults || guestData.numberOfAdults === 1
            ? 2
            : guestData.numberOfAdults,
        numberOfChildren: editvalue?.numberOfChildren ?? 0,
        age: guestData.guestId?.dateOfBirth
          ? calculateAge(guestData.guestId?.dateOfBirth?.split("T")[0])
          : null,
        nightCheckInConfirmed: formData.nightCheckInConfirmed,
        ...(selectedRoomId && {
          roomNumber: selectedRoomId,
        }),
        signature: isEdit ? editvalue.signature : null,
        otherGuests:
          guestData.otherGuests?.length > 0
            ? guestData.otherGuests?.map((g) => ({
              ...g,
              signature: null,
            }))
            : [
              {
                fullName: "",
                mobileNumber: guestData.guestId?.mobileNumber,
                documentType: "",
                documentNumber: "",
                dateOfBirth: "",
                documentUrl: [],
                address: "",
                signature: null,
              },
            ],
      }));
      setSuggestions([]);
      setnameSuggestions([]);
    }
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;
    const isEmpty = (value) => !value || !value.toString().trim();
    if (
      isEmpty(formData.mobileNumber) ||
      !/^\d{10}$/.test(formData.mobileNumber.trim())
    ) {
      errors.mobileNumber = "Please enter a valid 10-digit mobile number";
      isValid = false;
    }
    if (isEmpty(formData.firstName)) {
      errors.firstName = "First name is required";
      isValid = false;
    }
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isEmpty(formData.emailAddress) && !isValidEmail(formData.emailAddress.trim())) {
      errors.emailAddress = "Please enter valid email address";
      isValid = false;
    }

    if (isEmpty(formData.roomNumber)) {
      errors.roomNumber = "Room number is required";
      isValid = false;
    }

    if (isEmpty(new Date(`${formData.checkInDate} ${formData.checkInTime}`))) {
      errors.checkInDate_Time = "Check-in date/time is required";
      isValid = false;
    }
    if (
      !isEmpty(new Date(`${formData.checkInDate}T${formData.checkInTime}`)) &&
      !isEmpty(new Date(`${formData.checkOutDate}T${formData.checkOutTime}`))
    ) {
      const checkIn = new Date(
        `${formData.checkInDate}T${formData.checkInTime}`
      );
      const checkOut = new Date(
        `${formData.checkOutDate}T${formData.checkOutTime}`
      );

      if (checkOut <= checkIn) {
        errors.checkOutDate_Time = "Check-out must be after check-in time";
        isValid = false;
      }
    }

    if (!formData.numberOfAdults || formData.numberOfAdults < 1) {
      errors.numberOfAdults = "At least 1 adult is required";
      isValid = false;
    }

    if (!isEdit && !formData.signature && !formData.signature) {
      errors.signature = "Signature is required";
      isValid = false;
    }

    formData.otherGuests?.forEach((guest, index) => {
      if (guest.fullName && guest.fullName.trim().length < 10) {
        errors[`otherGuest_fullName_${index}`] = `Guest ${index + 1
          } full name must be at least 10 characters`;
        isValid = false;
      }

      if (!guest.signature) {
        errors[`otherGuest_signature_${index}`] = `Guest ${index + 1
          } signature is required`;
        isValid = false;
      }
    });

    return { isValid, errors };
  };

  const handleChange = async (e) => {
    if (role === "view only") return;
    setErrmsg("");
    const { name, value, selectionStart } = e.target;
    const noUpperCaseFields = [
      "documentType",
      "state",
      "country",
      "roomNumber",
      "dateOfBirth",
      "vehicleType",
      "numberOfAdults",
      "numberOfChildren",
      "advancePayAmount",
      "nightStay",
      "emailAddress",
    ];
    if (formErrors[name]) {
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    if (name === "mobileNumber") {
      const truncatedValue = value.slice(0, 10);
      setFormData((prevState) => ({
        ...prevState,
        mobileNumber: truncatedValue,
        phoneNumber: truncatedValue,
        otherGuests: prevState.otherGuests.map((guest) => ({
          ...guest,
          mobileNumber:
            guest.mobileNumber === prevState.mobileNumber
              ? truncatedValue // update only if it matched old main number
              : guest.mobileNumber, // keep as is otherwise
        })),
      }));

      setQuery(truncatedValue);
    } else if (name === "firstName") {
      // const noSpaceValue = value.replace(/\s+/g, "");
      const noSpaceValue = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      setFormData((prevState) => ({
        ...prevState,
        firstName: noSpaceValue.toUpperCase(),
        emailAddress:
          prevState.emailAddress?.split("@")[0] === prevState.firstName
            ? `${noSpaceValue.toUpperCase()}@GMAIL.COM`
            : prevState.emailAddress,
      }));
      setnameQuery(noSpaceValue.toUpperCase());
    } else if (name === "checkInDate_Time") {
      const selecteddate = value;
      const now = dateTime;
      if (isAfter(selecteddate, now)) {
        const [date, time] = now.split("T");
        setFormData((prevState) => ({
          ...prevState,
          checkInDate: date || "",
          checkInTime: time || "",
        }));
      } else {
        const [date, time] = selecteddate.split("T");
        setFormData((prevState) => ({
          ...prevState,
          checkInDate: date || "",
          checkInTime: time || "",
        }));
      }
    } else if (name === "checkOutDate_Time") {
      const selecteddate = value;
      const now = dateTime;
      if (isAfter(selecteddate, now)) {
        setFormData((prevState) => ({
          ...prevState,
          checkOutDate: "",
          checkOutTime: "",
        }));
      } else {
        const [date, time] = selecteddate.split("T");
        setFormData((prevState) => ({
          ...prevState,
          checkOutDate: date || "",
          checkOutTime: time || "",
        }));
      }
    } else if (name === "dateOfBirth") {
      setFormData((prevState) => ({
        ...prevState,
        dateOfBirth: value,
        age: value ? calculateAge(value) : null,
      }));
    } else {
      const keys = name.split(".");
      if (keys.length === 2) {
        if (formErrors[keys[1]]) {
          setFormErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[keys[1]];
            return newErrors;
          });
        }
        const processedValue = noUpperCaseFields.includes(keys[1])
          ? value
          : value.toUpperCase();

        setFormData((prevState) => ({
          ...prevState,
          [keys[0]]: {
            ...prevState[keys[0]],
            [keys[1]]: processedValue,
          },
        }));
      } else {
        const processedValue = noUpperCaseFields.includes(name)
          ? value
          : value.toUpperCase();
        setFormData((prevState) => ({
          ...prevState,
          [name]: processedValue,
        }));
      }
    }

    requestAnimationFrame(() => {
      const unsupportedTypes = [
        "email",
        "number",
        "datetime-local",
        "date",
        "time",
      ];

      if (
        e.target.setSelectionRange &&
        !unsupportedTypes.includes(e.target.type)
      ) {
        e.target.setSelectionRange(selectionStart, selectionStart);
      }
    });
  };

  const handleFileChange = async (e) => {
    if (role === "view only") return;
    const files = Array.from(e.target.files);
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 2 * 1024 * 1024;
    const maxSizeMB = maxSize / (1024 * 1024);

    setfileerr("");

    if (files.length > 6) {
      setfileerr("You can select up to 6 files only.");
      return;
    }

    const validFiles = files.filter(
      (file) => file.size <= maxSize && allowedTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      setfileerr(
        `Each file must be less than ${maxSizeMB}MB and in JPG, JPEG, or PNG format.`
      );
      return;
    }

    // Check if any required fields are empty
    const emptyFields = [];
    const fieldsToCheck = [
      "mobileNumber",
      "firstName",
      "lastName",
      "mobileNumber",
      "dateOfBirth",
      "documentNumber",
      "documentType",
      "address.address",
      "address.houseFlatNo",
      "address.locality",
      // "address.city",
      // "address.district",
      // "address.state",
      "address.zipCode",
    ];

    fieldsToCheck.forEach((field) => {
      const value = field.includes(".")
        ? field.split(".").reduce((obj, key) => obj && obj[key], formData)
        : formData[field];

      if (!value || (typeof value === "string" && value.trim() === "")) {
        emptyFields.push(field);
      }
    });

    // Only extract data if there are empty fields AND mobileNumber is empty
    if (emptyFields.length > 0) {
      setISextract(true); // Set loading state

      const formDataToSend = new FormData();
      validFiles.forEach((file) => {
        formDataToSend.append("files", file);
      });

      try {
        // const response = await extractData(formDataToSend);

        // Update form data only for empty fields
        setFormData((prevFormData) => {
          const updatedFormData = { ...prevFormData };

          // Helper function to check if a field is empty
          const isEmpty = (field) => {
            if (field.includes(".")) {
              const keys = field.split(".");
              const currentValue = keys.reduce(
                (obj, key) => obj && obj[key],
                prevFormData
              );
              return (
                !currentValue ||
                (typeof currentValue === "string" && currentValue.trim() === "")
              );
            }
            return (
              !prevFormData[field] ||
              (typeof prevFormData[field] === "string" &&
                prevFormData[field].trim() === "")
            );
          };

          // Update only empty fields
          // if (response.firstName && isEmpty("firstName")) {
          //   updatedFormData.firstName = response.firstName.toUpperCase();
          // }

          // if (response.middleName && isEmpty("middleName")) {
          //   updatedFormData.middleName = response.middleName.toUpperCase();
          // }

          // if (response.lastName && isEmpty("lastName")) {
          //   updatedFormData.lastName = response.lastName.toUpperCase();
          // }

          // if (response.dateOfBirth && isEmpty("dateOfBirth")) {
          //   updatedFormData.dateOfBirth = response.dateOfBirth;
          // }

          // if (response.documentNumber && isEmpty("documentNumber")) {
          //   updatedFormData.documentNumber = response.documentNumber;
          // }

          // if (response.documentType && isEmpty("documentType")) {
          //   updatedFormData.documentType = response.documentType;
          // }

          // // Update address fields only if empty
          // if (response.address && isEmpty("address.address")) {
          //   updatedFormData.address.address = response.address.toUpperCase();
          // }

          // if (response.houseFlatNo && isEmpty("address.houseFlatNo")) {
          //   updatedFormData.address.houseFlatNo =
          //     response.houseFlatNo.toUpperCase();
          // }

          // if (response.locality && isEmpty("address.locality")) {
          //   updatedFormData.address.locality = response.locality.toUpperCase();
          // }

          // if (response.zipcode && isEmpty("address.zipCode")) {
          //   updatedFormData.address.zipCode = response.zipcode;
          // }

          // // Only generate email if firstName was updated
          // if (
          //   response.firstName &&
          //   isEmpty("firstName") &&
          //   !updatedFormData.emailAddress
          // ) {
          //   updatedFormData.emailAddress = `${response.firstName.toUpperCase()}@GMAIL.COM`;
          // }

          return updatedFormData;
        });

        // console.log("Extracted data:", response);
      } catch (error) {
        console.error("API error:", error);
      } finally {
        setISextract(false); // Clear loading state
      }
    } else if (emptyFields.length === 0) {
      console.log("All fields already filled, skipping data extraction.");
    }
    setFormData((prev) => ({
      ...prev,
      documentUrl: validFiles,
    }));

    const newPreviews = validFiles.map((file) => URL.createObjectURL(file));
    setFilePreviews(newPreviews);
  };

  const handleGuestChange = (index, e) => {
    if (role === "view only") return;
    setErrmsg("");
    const { name, value, selectionStart } = e.target;
    const noUpperCaseFields = ["documentType", "dateOfBirth", "mobileNumber"];

    const errorKey = `otherGuest_${name}_${index}`;
    if (formErrors[errorKey]) {
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[errorKey];
        return newErrors;
      });
    }
    const updatedGuests = [...formData.otherGuests];
    let processedValue;
    if (name === "mobileNumber") {
      processedValue = value.slice(0, 10);
    } else if (noUpperCaseFields.includes(name)) {
      processedValue = value;
    } else {
      processedValue = value.toUpperCase();
    }
    updatedGuests[index][name] = processedValue;
    setFormData((prev) => ({
      ...prev,
      otherGuests: updatedGuests,
    }));

    requestAnimationFrame(() => {
      if (
        e.target.setSelectionRange && // make sure function exists
        e.target.type !== "email" && // skip email fields
        e.target.type !== "number" // skip number fields (optional)
      ) {
        e.target.setSelectionRange(selectionStart, selectionStart);
      }
    });
  };

  const addOtherGuest = () => {
    setFormData({
      ...formData,
      numberOfAdults: formData.numberOfAdults + 1,
      otherGuests: [
        ...formData.otherGuests,
        {
          fullName: "",
          mobileNumber: formData.mobileNumber,
          documentType: "",
          documentNumber: "",
          dateOfBirth: "",
          documentUrl: [],
          address: "",
          signature: null,
        },
      ],
    });
  };

  const handleGuestFileChange = async (index, e) => {
    if (role === "view only") return;

    const files = Array.from(e.target.files);
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 2 * 1024 * 1024;
    const maxSizeMB = maxSize / (1024 * 1024);
    const maxFiles = 2;

    // Clear previous errors
    const updatedErrors = [...guestFileErrors];
    updatedErrors[index] = "";
    setGuestFileErrors(updatedErrors);

    // Validation
    if (files.length > maxFiles) {
      updatedErrors[index] = `You can select up to ${maxFiles} files only.`;
      setGuestFileErrors(updatedErrors);
      return;
    }

    const validFiles = files.filter(
      (file) => file.size <= maxSize && allowedTypes.includes(file.type)
    );

    if (validFiles.length !== files.length) {
      updatedErrors[index] = `Each file must be less than ${maxSizeMB}MB and in JPG, JPEG, or PNG format.`;
      setGuestFileErrors(updatedErrors);
      return;
    }

    // Set loading state for this specific guest
    setFormData((prev) => {
      const updatedGuests = [...prev.otherGuests];
      updatedGuests[index] = {
        ...updatedGuests[index],
        isLoading: true // Add loading state
      };
      return { ...prev, otherGuests: updatedGuests };
    });

    // Check if any required fields are empty for this guest
    const currentGuest = formData.otherGuests[index];
    const requiredGuestFields = [
      'fullName',
      'documentNumber',
      'documentType',
      'address'
    ];

    // const hasEmptyFields = requiredGuestFields.some(field => {
    //   const value = currentGuest[field];
    //   return !value || (typeof value === 'string' && value.trim() === '');
    // });

    // Process image extraction only if there are empty fields
    // if (hasEmptyFields && validFiles.length > 0) {
    //   await processGuestImageExtraction(index, validFiles);
    // } else {
    // Just update the files without extraction
    updateGuestFiles(index, validFiles);
    // }

    // Clean up old preview URLs
    if (guestPreviewUrls[index]) {
      guestPreviewUrls[index].forEach((url) => URL.revokeObjectURL(url));
    }

    // Create new preview URLs
    const newPreviewUrls = validFiles.map((file) => URL.createObjectURL(file));
    setGuestPreviewUrls((prev) => {
      const updated = [...prev];
      updated[index] = newPreviewUrls;
      return updated;
    });

    // Clear loading state
    setFormData((prev) => {
      const updatedGuests = [...prev.otherGuests];
      updatedGuests[index] = {
        ...updatedGuests[index],
        isLoading: false
      };
      return { ...prev, otherGuests: updatedGuests };
    });
  };

  // Helper function to process guest image extraction
  // const processGuestImageExtraction = async (index, validFiles) => {
  //   try {
  //     const formDataPayload = new FormData();
  //     validFiles.forEach((file) => {
  //       formDataPayload.append("files", file);
  //     });

  //     const extractedData = await extractData(formDataPayload);

  //     // Update guest data with extracted values
  //     setFormData((prev) => {
  //       const updatedGuests = [...prev.otherGuests];
  //       const currentGuest = updatedGuests[index];

  //       // Helper function to check if field is empty
  //       const isEmpty = (field) => {
  //         const currentValue = currentGuest[field];
  //         return !currentValue || (typeof currentValue === 'string' && currentValue.trim() === '');
  //       };

  //       // Only update empty fields with extracted data
  //       updatedGuests[index] = {
  //         ...currentGuest,
  //         fullName: isEmpty('fullName') && extractedData.fullName 
  //           ? extractedData.fullName.toUpperCase() 
  //           : currentGuest.fullName,
  //         dateOfBirth: isEmpty('dateOfBirth') && extractedData.dateOfBirth
  //           ? extractedData.dateOfBirth
  //           : currentGuest.dateOfBirth,
  //         documentNumber: isEmpty('documentNumber') && extractedData.documentNumber
  //           ? extractedData.documentNumber
  //           : currentGuest.documentNumber,
  //         address: isEmpty('address', extractedData.address) && extractedData.address
  //           ? extractedData.address.toUpperCase()
  //           : currentGuest.address,
  //         documentType: isEmpty('documentType') && extractedData.documentType
  //           ? extractedData.documentType
  //           : currentGuest.documentType,
  //         documentUrl: validFiles, 
  //         // [...(currentGuest.documentUrl || []), ...validFiles],
  //         isLoading: false
  //       };

  //       return { ...prev, otherGuests: updatedGuests };
  //     });

  //   } catch (error) {
  //     console.error("API error for guest extraction:", error);
  //     updateGuestFiles(index, validFiles);
  //   }
  // };

  // Helper function to update guest files without extraction
  const updateGuestFiles = (index, validFiles) => {
    setFormData((prev) => {
      const updatedGuests = [...prev.otherGuests];
      updatedGuests[index] = {
        ...updatedGuests[index],
        documentUrl: validFiles
        // [...(updatedGuests[index].documentUrl || []), ...validFiles],
      };
      return { ...prev, otherGuests: updatedGuests };
    });
  };

  const removeGuest = (index) => {
    const newGuests = [...formData.otherGuests];
    newGuests.splice(index, 1);

    // Clean up preview URLs for removed guest
    if (guestPreviewUrls[index]) {
      guestPreviewUrls[index].forEach((url) => URL.revokeObjectURL(url));
      const updatedPreviews = [...guestPreviewUrls];
      updatedPreviews.splice(index, 1);
      setGuestPreviewUrls(updatedPreviews);
    }

    setFormData({
      ...formData,
      otherGuests: newGuests,
      numberOfAdults:
        formData.numberOfAdults - (index < formData.numberOfAdults - 1 ? 1 : 0),
    });
  };

  const handleSubmit = async () => {
    const { isValid, errors } = validateForm();
    const hasGuestFileErrors = guestFileErrors.some(
      (error) => error && error.length > 0
    );

    setFormErrors(errors);
    if (!isValid) {
      const firstErrorKey = Object.keys(errors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        firstErrorElement.focus();
      }
      setShowSubmitConfirmModal(false);
      setIsLoading(false);
      return;
    }
    if (fileerr || hasGuestFileErrors || errMsg) {
      setShowSubmitConfirmModal(false);
      setIsLoading(false);
      return;
    }
    const formDataPayload = new FormData();

    Object.keys(formData).forEach((key) => {
      if (key !== "signature") {
        if (key === "documentUrl") {
          formData[key].forEach((file) => {
            formDataPayload.append("documentUrl", file);
          });
        } else if (key === "address") {
          Object.keys(formData.address).forEach((field) => {
            formDataPayload.append(
              `address[${field}]`,
              formData.address[field]
            );
          });
        } else if (key === "advancePayAmount") {
          let advancePayvalue = formData[key];
          if (
            advancePayvalue === null ||
            advancePayvalue === undefined ||
            advancePayvalue === "" ||
            advancePayvalue === "null"
          ) {
            advancePayvalue = 0;
          } else {
            advancePayvalue = Number(advancePayvalue);
            if (isNaN(advancePayvalue)) advancePayvalue = 0;
          }

          formDataPayload.append(key, advancePayvalue);
        } else if (key === "expectedCheckoutHour") {
          let expectedCheckoutHourvalue = formData[key];
          if (
            expectedCheckoutHourvalue === null ||
            expectedCheckoutHourvalue === undefined ||
            expectedCheckoutHourvalue === "" ||
            expectedCheckoutHourvalue === "null"
          ) {
            expectedCheckoutHourvalue = 1;
          } else {
            expectedCheckoutHourvalue = Number(expectedCheckoutHourvalue);
            if (isNaN(expectedCheckoutHourvalue)) expectedCheckoutHourvalue = 1;
          }

          formDataPayload.append(key, expectedCheckoutHourvalue);
        } else if (key === "numberOfChildren") {
          let numberOfChildrenvalue = formData[key];
          if (
            numberOfChildrenvalue === null ||
            numberOfChildrenvalue === undefined ||
            numberOfChildrenvalue === "" ||
            numberOfChildrenvalue === "null"
          ) {
            numberOfChildrenvalue = 0;
          } else {
            numberOfChildrenvalue = Number(numberOfChildrenvalue);
            if (isNaN(numberOfChildrenvalue)) numberOfChildrenvalue = 0;
          }

          formDataPayload.append(key, numberOfChildrenvalue);
        } else if (key === "otherGuests") {
          formData.otherGuests.forEach((guest, index) => {
            Object.keys(guest).forEach((field) => {
              if (field === "documentUrl" && Array.isArray(guest[field])) {
                guest[field].forEach((file) => {
                  formDataPayload.append(
                    `otherGuests[${index}][documentUrl]`,
                    file
                  );
                });
              } else if (field === "dateOfBirth") {
                const value = guest[field] ? guest[field] : "";
                formDataPayload.append(
                  `otherGuests[${index}][${field}]`,
                  value
                );
              } else if (field !== "signature") {
                formDataPayload.append(
                  `otherGuests[${index}][${field}]`,
                  guest[field]
                );
              }
            });
          });
        } else {
          if (key === "nightCheckInConfirmed") {
            formDataPayload.append(key, JSON.stringify(formData[key]));
          } else if (key === "emailAddress") {
            formDataPayload.append(key, formData[key].toUpperCase());
          } else {
            formDataPayload.append(key, formData[key]);
          }
        }
      }
    });

    if (
      formData.signature &&
      (!isEdit || formData.signature.startsWith("data:image"))
    ) {
      try {
        const blob = await fetch(formData.signature).then((res) => res.blob());
        formDataPayload.append(
          "signature",
          blob,
          `${formData.firstName}_sign.png`
        );
      } catch (error) {
        console.error("Error converting signature:", error);
        return;
      }
    }
    for (const [index, guest] of formData.otherGuests.entries()) {
      if (guest.signature && guest.signature?.startsWith("data:image")) {
        const blob = await fetch(guest.signature).then((res) => res.blob());
        formDataPayload.append(
          `otherGuests[${index}][signature]`,
          blob,
          `${guest.fullName}_sign.png`
        );
      }
    }
    if (
      (formData.checkOutDate && formData.checkOutTime && !isEdit) ||
      (isEdit &&
        formData.checkOutDate &&
        formData.checkOutTime &&
        (editvalue.checkInDate !== formData.checkInDate ||
          editvalue.checkOutDate !== formData.checkOutDate ||
          editvalue.checkInTime !== formData.checkInTime ||
          editvalue.checkOutTime !== formData.checkOutTime))
    ) {
      Object.keys(billdetails).forEach((key) => {
        formDataPayload.append(`${key}`, billdetails[key]);
      });
    }
    // setIsLoading(true);
    try {
      let response;
      if (isEdit) {
        response = await updateGuest(formDataPayload);
      } else {
        response = await addGuest(formDataPayload);
      }

      if (response?.data?.status) {
        toast.success(response?.data?.msg);
        if (
          (formData.checkOutDate && formData.checkOutTime && !isEdit) ||
          (
            isEdit &&
            formData.checkOutDate &&
            formData.checkOutTime &&
            !editvalue.checkOutDate?.trim()
          )
        ) {
          setCreditToupdate(true);
        }
        setFormData({ ...initialFormState, documentUrl: [] });
        setFormToShow(null);
        setIsLoading(false);
        setShowSubmitConfirmModal(false);
        await action(initialPage);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
      setErrmsg(error?.response?.data?.msg);
    } finally {
      setShowSubmitConfirmModal(false);
      setisEdit(false);
      setIsLoading(false);
    }
  };

  const handlecancel = () => {
    setErrmsg("");
    setFormData(initialFormState);
    setFormToShow(null);
    setShowPdfPreview(false);
    setEditvalue({});
    setisEdit(false);
  };

  const isRoomUnderCleaning = () => {
    const room = roomData.find((room) => room._id === formData.roomNumber);
    return room ? room.underCleaning : null;
  };

  const renderNightCheckInCheckbox = () => {
    if (!shouldShowCheckboxFn()) return null;

    return (
      <div className="flex">
        <label className="inline-flex items-center mt-3">
          <input
            type="checkbox"
            name="nightCheckInConfirmed"
            checked={formData.nightCheckInConfirmed || false}
            onChange={(e) => {
              if (role === "view only" || editvalue.checkOutDate) return;
              setFormData((prev) => ({
                ...prev,
                nightCheckInConfirmed: e.target.checked,
              }));
            }}
            disabled={editvalue.checkOutDate}
            className="form-checkbox h-5 w-5 text-indigo-600 rounded focus:ring-indigo-500"
          />
          <span className="ml-2 text-sm font-medium text-gray-700">
            Confirm Night Check-In*
          </span>
        </label>
      </div>
    );
  };

  const states = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kenmore",
    "Kerala",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Narora",
    "Natwar",
    "Odisha",
    "Paschim Medinipur",
    "Pondicherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "Vaishali",
    "West Bengal",
  ];

  const country = ["India"];

  return (
    <>
      <div
        className="fixed inset-0 z-50 overflow-y-auto"
        style={{
          overflow: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center">
          <div className="fixed inset-0 transition-opacity" aria-hidden="true">
            <div
              className="absolute inset-0 bg-gray-500 opacity-75"
              onClick={() => setShowCancelModal(true)}
            ></div>
          </div>
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full">
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4 text-center">
                Guest and Check-In Form
              </h3>

              <form
                onSubmit={(e) => {
                  console.log("Form submitted");
                  e.preventDefault();
                  setShowSubmitConfirmModal(true);
                }}
                className="space-y-4 guest-form"
              >
                <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-4 rounded-lg">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {renderNightCheckInCheckbox()}

                    <MobileNumberDropdown
                      formData={formData}
                      formErrors={formErrors}
                      handleChange={handleChange}
                      handleSuggestionClick={handleSuggestionClick}
                      suggestions={suggestions}
                      loading={loading}
                      setSuggestions={setSuggestions}
                      setLoading={setLoading}
                      query={query}
                      editvalue={editvalue}
                    />
                    <div className="flex">
                      <label className="inline-flex items-center mt-3">
                        <input
                          type="checkbox"
                          name="noPathikEntry"
                          checked={formData.noPathikEntry || false}
                          onChange={(e) => {
                            if (role === "view only") return;
                            setFormData((prev) => ({
                              ...prev,
                              noPathikEntry: e.target.checked,
                            }));
                          }}
                          className="form-checkbox h-5 w-5 text-indigo-600 rounded focus:ring-indigo-500"
                        />
                        <span className="ml-2 text-sm font-medium text-gray-700">
                          No pthk
                        </span>
                      </label>
                    </div>
                    <NamesearchDropdown
                      formData={formData}
                      formErrors={formErrors}
                      handleChange={handleChange}
                      handleSuggestionClick={handleSuggestionClick}
                      namesuggestions={namesuggestions}
                      nameloading={nameloading}
                      setnameSuggestions={setnameSuggestions}
                      setnameLoading={setnameLoading}
                      namequery={namequery}
                    />
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Middle Name
                      </label>
                      <input
                        type="text"
                        name="middleName"
                        value={formData.middleName}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Last Name*
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      />
                      {/* {formErrors.lastName && (
                        <p className="mt-1 text-sm text-red-600">
                          {formErrors.lastName}
                        </p>
                      )} */}
                    </div>

                    <div className="">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Date of Birth*
                      </label>

                      <DatePicker
                        selected={
                          formData.dateOfBirth
                            ? new Date(formData.dateOfBirth)
                            : null
                        }
                        onChange={(date) => {
                          if (date) {
                            const year = date.getFullYear();
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            );
                            const day = String(date.getDate()).padStart(2, "0");
                            const dateString = `${year}-${month}-${day}`; // yyyy-MM-dd format

                            handleChange({
                              target: {
                                name: "dateOfBirth",
                                value: dateString,
                              },
                            });
                          } else {
                            handleChange({
                              target: {
                                name: "dateOfBirth",
                                value: "",
                              },
                            });
                          }
                        }}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="DD/MM/YYYY"
                        maxDate={subYears(new Date(), 18)}
                        showPopperArrow={false}
                        wrapperClassName="w-full"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-black cursor-text focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        onInputClick={() => {
                          if (!formData.dateOfBirth) {
                            handleChange({
                              target: {
                                name: "dateOfBirth",
                                value: "",
                              },
                            });
                          }
                        }}
                        onChangeRaw={(e) => {
                          const input =
                            e.target.value?.replace(/\D/g, "") || "";
                          let formatted = "";

                          if (input.length > 0) {
                            formatted = input.substring(0, 2);
                          }
                          if (input.length > 2) {
                            formatted += "/" + input.substring(2, 4);
                          }
                          if (input.length > 4) {
                            formatted += "/" + input.substring(4, 8);
                          }

                          e.target.value = formatted;

                          // Only validate if we have a complete date
                          if (input.length === 8) {
                            const day = parseInt(input.substring(0, 2), 10);
                            const month =
                              parseInt(input.substring(2, 4), 10) - 1; // months are 0-indexed
                            const year = parseInt(input.substring(4, 8), 10);
                            const date = new Date(year, month, day);
                            const eighteenYearsAgo = subYears(new Date(), 18);
                            if (
                              !isNaN(date.getTime()) &&
                              date <= eighteenYearsAgo
                            ) {
                              // Valid date, update state
                              const dateString = `${year}-${String(
                                month + 1
                              ).padStart(2, "0")}-${String(day).padStart(
                                2,
                                "0"
                              )}`;
                              handleChange({
                                target: {
                                  name: "dateOfBirth",
                                  value: dateString,
                                },
                              });
                            } else {
                              // Invalid date, clear state and input
                              handleChange({
                                target: {
                                  name: "dateOfBirth",
                                  value: "",
                                },
                              });
                              e.target.value = ""; // Clear the input field
                            }
                          } else if (input.length < 8 && input.length > 0) {
                            // Partial input, clear state but keep the partial input in the field
                            handleChange({
                              target: {
                                name: "dateOfBirth",
                                value: "",
                              },
                            });
                          }
                        }}
                      />

                      {formData.age && formData.dateOfBirth && (
                        <p className="mt-1 text-xs text-gray-500">
                          Age: {formData.age.years} years, {formData.age.months}{" "}
                          months, {formData.age.days} days old
                        </p>
                      )}
                      {formErrors.dateOfBirth && (
                        <p className="mt-1 text-sm text-red-600">
                          {formErrors.dateOfBirth}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email*
                      </label>
                      <input
                        type="email"
                        name="emailAddress"
                        value={formData.emailAddress}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm uppercase"
                      />
                      {formErrors.emailAddress && (
                        <p className="mt-1 text-sm text-red-600">
                          {formErrors.emailAddress}
                        </p>
                      )}
                    </div>

                    <div className="">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Company Name
                      </label>
                      <input
                        type="text"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      />
                    </div>
                    <div className="hidden">
                      <label className="block text-sm font-medium text-gray-700">
                        Phone Number*
                      </label>
                      <input
                        type="text"
                        name="phoneNumber"
                        value={formData.mobileNumber}
                        readOnly
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-4 rounded-lg">
                  <div className="grid grid-cols-1 gap-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          House/Flat No
                        </label>
                        <input
                          type="text"
                          name="address.houseFlatNo"
                          value={formData.address.houseFlatNo}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />
                      </div>

                      <div className="">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Locality*
                        </label>
                        <input
                          type="text"
                          name="address.locality"
                          value={formData.address.locality}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />
                        {/* {formErrors.locality && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.locality}
                          </p>
                        )} */}
                      </div>
                      {/* Second Row: Address (full width) */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Address*
                        </label>
                        <textarea
                          name="address.address"
                          value={formData.address.address}
                          onChange={handleChange}
                          rows="2"
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        ></textarea>
                        {/* {formErrors.address && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.address}
                          </p>
                        )} */}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          City*
                        </label>
                        <input
                          type="text"
                          name="address.city"
                          value={formData.address.city}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />
                        {/* {formErrors.city && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.city}
                          </p>
                        )} */}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          District*
                        </label>
                        <input
                          type="text"
                          name="address.district"
                          value={formData.address.district}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />
                        {/* {formErrors.district && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.district}
                          </p>
                        )} */}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          State*
                        </label>
                        <select
                          name="address.state"
                          value={formData.address.state}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        >
                          <option value="">Select State</option>
                          {states.map((state) => (
                            <option key={state} value={state}>
                              {state}
                            </option>
                          ))}
                        </select>
                        {/* {formErrors.state && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.state}
                          </p>
                        )} */}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Zip Code*
                        </label>
                        <input
                          type="number"
                          name="address.zipCode"
                          value={formData.address.zipCode}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />
                        {/* {formErrors.zipCode && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.zipCode}
                          </p>
                        )} */}
                      </div>
                    </div>

                    <div className="hidden">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Country
                      </label>
                      <select
                        name="address.country"
                        value={formData.address.country || "India"}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        tabIndex="-1"
                      >
                        <option value="">Select Country</option>
                        {country.map((country) => (
                          <option key={country} value={country}>
                            {country}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-4">
                  <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-4 rounded-lg">
                    <div className="grid grid-cols-1 gap-4">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Document Type*
                          </label>
                          <select
                            name="documentType"
                            value={formData.documentType}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            <option value="">Select Document Type</option>
                            <option value="Aadhar Card">Aadhar Card</option>
                            <option value="Election Card">Election Card</option>
                            <option value="Driving License">
                              Driving License
                            </option>
                            <option value="Pan Card">Pan Card</option>
                            <option value="Passport No">Passport No</option>
                          </select>
                          {/* {formErrors.documentType && (
                            <p className="mt-1 text-sm text-red-600">
                              {formErrors.documentType}
                            </p>
                          )} */}
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Document Number*
                          </label>
                          <input
                            type="text"
                            name="documentNumber"
                            value={formData.documentNumber}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          />
                          {/* {formErrors.documentNumber && (
                            <p className="mt-1 text-sm text-red-600">
                              {formErrors.documentNumber}
                            </p>
                          )} */}
                        </div>
                        <div>
                          <div className="flex gap-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Document Images*
                            </label>
                            {/* Show loader when processing images */}
                            {isextract && (
                              <div className="flex items-center ml-2">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-indigo-600"></div>
                                <span className="ml-2 text-sm text-gray-500">
                                  Processing images...
                                </span>
                              </div>
                            )}
                            <div className="flex gap-2 flex-wrap">
                              {formData.documentUrl?.map((file, index) => {
                                const previewUrl = filePreviews?.[index];
                                const imageUrl = previewUrl
                                  ? previewUrl
                                  : typeof file === "string"
                                    ? `${process.env.REACT_APP_BASE_URL}/${file}`
                                    : URL.createObjectURL(file);

                                return (
                                  <img
                                    key={index}
                                    src={imageUrl}
                                    alt="Uploaded"
                                    className="w-6 h-6 object-cover rounded-md shadow border"
                                    onClick={() => {
                                      if (isEdit) {
                                        setSelectedImage(imageUrl);
                                        setIsModalOpen(true);
                                      }
                                    }}
                                  />
                                );
                              })}
                            </div>
                          </div>
                          <input
                            files={formData.documentUrl}
                            type="file"
                            name="documentUrl"
                            onChange={handleFileChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm bg-white"
                            accept=".jpg,.jpeg,.png"
                            multiple
                          />
                          {fileerr && (
                            <p className="mt-1 text-sm text-red-600">
                              {fileerr}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-4 rounded-lg ">
                    <div className="grid grid-cols-1 gap-4">
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Coming From*
                          </label>
                          <input
                            type="text"
                            name="comingFrom"
                            value={formData.comingFrom}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          />
                          {/* {formErrors.comingFrom && (
                            <p className="mt-1 text-sm text-red-600">
                              {formErrors.comingFrom}
                            </p>
                          )} */}
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Going To*
                          </label>
                          <input
                            type="text"
                            name="goingTo"
                            value={formData.goingTo}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          />
                          {/* {formErrors.goingTo && (
                            <p className="mt-1 text-sm text-red-600">
                              {formErrors.goingTo}
                            </p>
                          )} */}
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Vehicle Type
                          </label>
                          <select
                            name="vehicleType"
                            value={formData.vehicleType}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          >
                            <option value="">Select Vehicle Type</option>
                            <option value="Car">Car</option>
                            <option value="Bike">Bike</option>
                            <option value="Bus">Bus</option>
                            <option value="Auto">Auto</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Vehicle Number
                          </label>
                          <input
                            type="text"
                            name="vehicleRegistrationNo"
                            value={formData.vehicleRegistrationNo}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-4 rounded-lg">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Room Number*
                      </label>
                      <select
                        name="roomNumber"
                        value={formData.roomNumber}
                        disabled={
                          (isEdit && isRoomUnderCleaning()) ||
                          editvalue.checkOutDate
                        }
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      >
                        <option value="">Select Room</option>
                        {roomData
                          .filter((room) => {
                            if (isEdit) {
                              return room.roomStatus !== false;
                            } else {
                              return (
                                room.roomStatus !== false &&
                                room.status !== "booked" &&
                                !room.underCleaning
                              );
                            }
                          })
                          .map((room) => (
                            <option
                              disabled={
                                room.status === "booked" || room.underCleaning
                              }
                              key={room._id}
                              value={room._id}
                              className={
                                room.status === "booked"
                                  ? "bg-red-100 text-red-800"
                                  : ""
                              }
                            >
                              {room.roomNo}
                            </option>
                          ))}
                      </select>
                      {formErrors.roomNumber && (
                        <p className="mt-1 text-sm text-red-600">
                          {formErrors.roomNumber}
                        </p>
                      )}
                    </div>

                    <div className="w-full">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Check-In*
                      </label>
                      <div className="relative w-full">
                        {/* Fake input showing formatted value */}
                        <input
                          type="text"
                          value={
                            formData.checkInDate && formData.checkInTime
                              ? format(
                                new Date(
                                  `${formData.checkInDate}T${formData.checkInTime}`
                                ),
                                "dd/MM/yyyy hh:mm a"
                              )
                              : ""
                          }
                          readOnly
                          onFocus={() => {
                            ((isEdit && role === "manager" && editvalue.checkOutDate) || !isEdit)
                              && document
                                .getElementById("checkin-picker")
                                .showPicker();
                          }}
                          // onFocus={() =>
                          //   ((isEdit && role === "manager" && editvalue.checkOutDate)||!editvalue.checkOutDate)
                          //    &&
                          //   document
                          //     .getElementById("checkin-picker")
                          //     .showPicker()
                          // }
                          className="absolute top-0 left-0 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-black cursor-pointer focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm z-10"
                        />
                        {/* Actual datetime-local input */}
                        <input
                          type="datetime-local"
                          id="checkin-picker"
                          name="checkInDate_Time"
                          value={
                            formData.checkInDate && formData.checkInTime
                              ? `${formData.checkInDate}T${formData.checkInTime}`
                              : ""
                          }
                          onChange={handleChange}
                          tabIndex="-1"
                          max={dateTime}
                          required
                          // readOnly={!role === "manager"}
                          // readOnly={isEdit}
                          className={`w-full px-0 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm bg-transparent ${!isEdit
                            ? "text-transparent caret-transparent z-0"
                            : "text-black"
                            }`}
                        />
                      </div>
                    </div>

                    <div className="w-full">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Check-Out
                      </label>

                      <div className="relative w-full">
                        {/* Fake input showing formatted date */}

                        <input
                          type="text"
                          value={
                            formData.checkOutDate && formData.checkOutTime
                              ? format(
                                new Date(
                                  `${formData.checkOutDate}T${formData.checkOutTime}`
                                ),
                                "dd/MM/yyyy hh:mm a"
                              )
                              : ""
                          }
                          readOnly
                          onFocus={() => {
                            ((isEdit && role === "manager") || !isEdit)
                              &&
                              document
                                .getElementById("checkout-picker")
                                .showPicker();
                          }}
                          className="absolute top-0 left-0 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-black cursor-pointer focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />

                        {/* Actual datetime-local input */}
                        <input
                          type="datetime-local"
                          id="checkout-picker"
                          name="checkOutDate_Time"
                          value={
                            formData.checkOutDate && formData.checkOutTime
                              ? `${formData.checkOutDate}T${formData.checkOutTime}`
                              : ""
                          }
                          onChange={handleChange}
                          // readOnly={!role === "manager"}
                          tabIndex="-1"
                          className={`w-full px-0 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm bg-transparent ${!isEdit
                            ? "text-transparent caret-transparent z-0"
                            : "text-black"
                            }`}
                        />
                      </div>

                      {formErrors.checkOutDate_Time && (
                        <p className="mt-1 text-sm text-red-600">
                          {formErrors.checkOutDate_Time}
                        </p>
                      )}
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Adults*
                        </label>
                        <input
                          type="number"
                          name="numberOfAdults"
                          value={formData.numberOfAdults}
                          min="1"
                          readOnly
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          required
                          onWheel={(e) => e.target.blur()}
                        />
                        {formErrors.numberOfAdults && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.numberOfAdults}
                          </p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Children*
                        </label>
                        <input
                          type="number"
                          name="numberOfChildren"
                          value={formData.numberOfChildren}
                          onChange={handleChange}
                          min="0"
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          readOnly={editvalue.checkOutDate}
                          // required={isEdit}
                          onWheel={(e) => e.target.blur()}
                        />
                        {formErrors.numberOfChildren && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.numberOfChildren}
                          </p>
                        )}
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Advance Pay Amount*
                      </label>
                      <input
                        type="number"
                        name="advancePayAmount"
                        value={formData.advancePayAmount}
                        onChange={handleChange}
                        onWheel={(e) => e.target.blur()}
                        min="0"
                        readOnly={editvalue.checkOutDate && role !== "manager"}
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      />
                      {formErrors.advancePayAmount && (
                        <p className="mt-1 text-sm text-red-600">
                          {formErrors.advancePayAmount}
                        </p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Expected Checkout Hour*
                      </label>
                      <input
                        type="number"
                        name="expectedCheckoutHour"
                        value={formData.expectedCheckoutHour}
                        onChange={handleChange}
                        readOnly={editvalue.checkOutDate}
                        onWheel={(e) => e.target.blur()}
                        min="1"
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      />
                      {formErrors.expectedCheckoutHour && (
                        <p className="mt-1 text-sm text-red-600">
                          {formErrors.expectedCheckoutHour}
                        </p>
                      )}
                    </div>

                    {/* <div className="flex items-center">
                      <input
                        type="checkbox"
                        id="noPathikEntry"
                        name="noPathikEntry"
                        checked={formData.noPathikEntry || false}
                        onChange={handleChange}
                        className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                      />
                      <label
                        htmlFor="noPathikEntry"
                        className="ml-2 block text-sm text-gray-700"
                      >
                        No Pathik Entry
                      </label>
                    </div> */}
                  </div>
                </div>

                {formData.otherGuests?.map((guest, index) => (
                  <div
                    key={index}
                    className="bg-gradient-to-r from-indigo-50 to-blue-50 p-4 rounded-lg border border-gray-200 mb-4"
                  >
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-sm font-semibold text-gray-700">
                        Guest {index + 1}
                      </h3>
                      <button
                        type="button"
                        disabled={
                          role === "view only" || editvalue.checkOutDate
                        }
                        onClick={() => removeGuest(index)}
                        className="text-red-600 hover:text-red-800 text-sm font-medium"
                      >
                        Remove Guest
                      </button>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Full Name*
                        </label>
                        <input
                          type="text"
                          name="fullName"
                          value={guest.fullName}
                          onChange={(e) => handleGuestChange(index, e)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          minLength="10"
                        />
                        {formErrors[`otherGuest_fullName_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors[`otherGuest_fullName_${index}`]}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Mobile Number*
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          name="mobileNumber"
                          value={guest.mobileNumber}
                          onChange={(e) => handleGuestChange(index, e)}
                          pattern="[1-9]{1}"
                          inputMode="numeric"
                          maxLength="10"
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />
                        {/* {formErrors[`otherGuest_mobileNumber_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors[`otherGuest_mobileNumber_${index}`]}
                          </p>
                        )} */}
                      </div>
                      <div className="w-full">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Date of Birth*
                        </label>
                        <DatePicker
                          selected={
                            guest.dateOfBirth
                              ? new Date(guest.dateOfBirth)
                              : null
                          }
                          onChange={(date) => {
                            if (date) {
                              const year = date.getFullYear();
                              const month = String(
                                date.getMonth() + 1
                              ).padStart(2, "0");
                              const day = String(date.getDate()).padStart(
                                2,
                                "0"
                              );
                              const dateString = `${year}-${month}-${day}`; // yyyy-MM-dd format

                              handleGuestChange(index, {
                                target: {
                                  name: "dateOfBirth",
                                  value: dateString,
                                },
                              });
                            } else {
                              handleGuestChange(index, {
                                target: {
                                  name: "dateOfBirth",
                                  value: "",
                                },
                              });
                            }
                          }}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="DD/MM/YYYY"
                          maxDate={
                            new Date(
                              new Date().setFullYear(
                                new Date().getFullYear() - 18
                              )
                            )
                          }
                          showPopperArrow={false}
                          wrapperClassName="w-full"
                          // customInput={<CustomDateInput />}
                          onInputClick={() => {
                            if (!formData.dateOfBirth) {
                              handleChange({
                                target: {
                                  name: "dateOfBirth",
                                  value: "",
                                },
                              });
                            }
                          }}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-black cursor-text focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                          onChangeRaw={(e) => {
                            const input =
                              e.target.value?.replace(/\D/g, "") || "";
                            let formatted = "";

                            if (input.length > 0) {
                              formatted = input.substring(0, 2);
                            }
                            if (input.length > 2) {
                              formatted += "/" + input.substring(2, 4);
                            }
                            if (input.length > 4) {
                              formatted += "/" + input.substring(4, 8);
                            }

                            e.target.value = formatted;

                            // Only validate if we have a complete date
                            if (input.length === 8) {
                              const day = parseInt(input.substring(0, 2), 10);
                              const month =
                                parseInt(input.substring(2, 4), 10) - 1; // months are 0-indexed
                              const year = parseInt(input.substring(4, 8), 10);
                              const date = new Date(year, month, day);
                              const eighteenYearsAgo = subYears(new Date(), 18);

                              if (
                                !isNaN(date.getTime()) &&
                                date <= eighteenYearsAgo
                              ) {
                                // Valid date, update state
                                const dateString = `${year}-${String(
                                  month + 1
                                ).padStart(2, "0")}-${String(day).padStart(
                                  2,
                                  "0"
                                )}`;
                                handleGuestChange(index, {
                                  target: {
                                    name: "dateOfBirth",
                                    value: dateString,
                                  },
                                });
                              } else {
                                // Invalid date, clear state and input
                                handleGuestChange(index, {
                                  target: {
                                    name: "dateOfBirth",
                                    value: "",
                                  },
                                });
                                e.target.value = ""; // Clear the input field
                              }
                            } else if (input.length < 8 && input.length > 0) {
                              // Partial input, clear state but keep the partial input in the field
                              handleGuestChange(index, {
                                target: {
                                  name: "dateOfBirth",
                                  value: "",
                                },
                              });
                            }
                          }}
                        />
                        {guest.dateOfBirth &&
                          (() => {
                            const age = calculateAge(
                              guest.dateOfBirth.split("T")[0]
                            );
                            return (
                              <p className="mt-1 text-xs text-gray-500">
                                Age: {age.years} years, {age.months} months,{" "}
                                {age.days} days old
                              </p>
                            );
                          })()}

                        {/* {formErrors[`otherGuest_dateOfBirth_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors[`otherGuest_dateOfBirth_${index}`]}
                          </p>
                        )} */}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Document Type*
                        </label>
                        <select
                          name="documentType"
                          value={guest.documentType}
                          onChange={(e) => handleGuestChange(index, e)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        >
                          <option value="">Select Document Type</option>
                          <option value="Aadhar Card">Aadhar Card</option>
                          <option value="Election Card">Election Card</option>
                          <option value="Driving License">
                            Driving License
                          </option>
                          <option value="Pan Card">Pan Card</option>
                          <option value="Passport No">Passport No</option>
                        </select>
                        {/* {formErrors[`otherGuest_documentType_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors[`otherGuest_documentType_${index}`]}
                          </p>
                        )} */}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Document Number*
                        </label>
                        <input
                          type="text"
                          name="documentNumber"
                          value={guest.documentNumber}
                          onChange={(e) => handleGuestChange(index, e)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        />
                        {/* {formErrors[`otherGuest_documentNumber_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors[`otherGuest_documentNumber_${index}`]}
                          </p>
                        )} */}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Document Images
                        </label>
                        <div className="flex items-center gap-4">
                          <div className="flex-1">
                            <input
                              type="file"
                              name="documentUrl"
                              onChange={(e) => handleGuestFileChange(index, e)}
                              className="w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                              accept=".jpg,.jpeg,.png"
                              multiple
                            />
                          </div>
                          {guest.isLoading && (
                            <div className="flex items-center ml-2">
                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-indigo-600"></div>
                            </div>
                          )}
                          <div className="flex gap-2">
                            {(Array.isArray(guest.documentUrl)
                              ? guest.documentUrl
                              : []
                            ).map((file, fileIndex) => {
                              const imageUrl =
                                typeof file === "string"
                                  ? `${process.env.REACT_APP_BASE_URL}/${file}`
                                  : guestPreviewUrls[index]?.[fileIndex] || "";
                              return (
                                <div key={fileIndex} className="relative">
                                  {imageUrl && (
                                    <img
                                      src={imageUrl}
                                      alt="Document"
                                      className="w-10 h-10 object-cover rounded border border-gray-300"
                                      onClick={() => {
                                        if (isEdit) {
                                          setSelectedImage(imageUrl);
                                          setIsModalOpen(true);
                                        }
                                      }}
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        {guestFileErrors[index] && (
                          <p className="mt-1 text-sm text-red-600">
                            {guestFileErrors[index]}
                          </p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Address*
                        </label>
                        <textarea
                          name="address"
                          value={guest.address}
                          onChange={(e) => handleGuestChange(index, e)}
                          rows="2"
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none  focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        ></textarea>
                        {formErrors[`otherGuest_address_${index}`] && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors[`otherGuest_address_${index}`]}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className="flex flex-start">
                        {guest.signature &&
                          (isEdit ||
                            guest.signature?.startsWith("data:image")) ? (
                          <div className="flex flex-col items-start">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Guest {index + 1} Signature
                            </label>
                            <div className="flex items-center flex-col md:flex-row justify-center gap-4 w-full">
                              <div className="flex-1 max-w-xs">
                                <img
                                  src={
                                    guest.signature?.startsWith("data:image")
                                      ? guest.signature
                                      : `${process.env.REACT_APP_BASE_URL}/${guest.signature}`
                                  }
                                  alt={`Guest ${index + 1} Signature`}
                                  className="border rounded-lg min-w-64 h-32 object-contain bg-white"
                                />
                              </div>
                              {(!isEdit || !editvalue.checkOutDate) &&
                                role !== "view only" && (
                                  <button
                                    type="button"
                                    onClick={() => handleStartSignature(index)}
                                    className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700"
                                  >
                                    Re-sign
                                  </button>
                                )}
                            </div>
                          </div>
                        ) : (
                          <div className="flex flex-col items-start">
                            <button
                              type="button"
                              onClick={() => handleStartSignature(index)}
                              className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700"
                            >
                              <svg
                                className="w-5 h-5 mr-2"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                ></path>
                              </svg>
                              Guest {index + 1} Signature
                            </button>
                            {formErrors[`otherGuest_signature_${index}`] && (
                              <p className="mt-1 text-sm text-red-600">
                                {formErrors[`otherGuest_signature_${index}`]}
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                <div className="flex justify-center">
                  <button
                    type="button"
                    onClick={addOtherGuest}
                    disabled={role === "view only" || editvalue.checkOutDate}
                    className="flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <svg
                      className="-ml-1 mr-2 h-5 w-5 text-indigo-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Add Another Guest
                  </button>
                </div>

                <div className="">
                  <div className="flex flex-start">
                    {formData.signature ? (
                      <div className="flex flex-col items-start">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {isEdit &&
                            !formData.signature?.startsWith("data:image")
                            ? "Current Signature"
                            : "Signature Preview"}
                        </label>
                        <div className="flex md:items-center flex-col md:flex-row items-start justify-center gap-4 w-full">
                          <div className="flex-1 max-w-xs">
                            <img
                              src={
                                formData.signature?.startsWith("data:image")
                                  ? formData.signature
                                  : `${process.env.REACT_APP_BASE_URL}/${formData.signature}`
                              }
                              alt="Signature Preview"
                              className="border rounded-lg min-w-64 h-32 object-contain bg-white"
                            />
                          </div>
                          {/* Show Re-sign button if not checked out (no checkoutDateTime) */}
                          {(!isEdit || !editvalue.checkOutDate) &&
                            role !== "view only" && (
                              <button
                                type="button"
                                onClick={() => handleStartSignature()}
                                className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700"
                              >
                                Re-sign
                              </button>
                            )}
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col">
                        <button
                          type="button"
                          onClick={() => handleStartSignature()}
                          className="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700"
                        >
                          <svg
                            className="w-5 h-5 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                            ></path>
                          </svg>
                          Provide Signature
                        </button>
                        {formErrors.signature && (
                          <p className="mt-1 text-sm text-red-600">
                            {formErrors.signature}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {errMsg && (
                  <p className="mt-2 text-sm text-red-600">{errMsg}</p>
                )}
                <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
                  <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                    {role !== "view only" && (
                      <>
                        <button
                          type="submit"
                          className={`inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 ${isLoading ? "opacity-70 cursor-not-allowed" : ""
                            }`}
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <svg
                                className="mr-2 h-4 w-4 animate-spin"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              {isEdit ? "Updating..." : "Submitting..."}
                            </>
                          ) : isEdit ? (
                            "Update"
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </>
                    )}

                    <button
                      type="button"
                      onClick={() => setShowCancelModal(true)}
                      className="inline-flex justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-indigo-500"
                    >
                      Cancel
                    </button>
                  </div>
                  {isEdit &&
                    formData.isCompleteCheckInData &&
                    editvalue.checkOutDate &&
                    role !== "view only" && (
                      <button
                        type="button"
                        onClick={() => setShowPdfPreview(true)}
                        className="inline-flex items-center justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-green-500"
                      >
                        <svg
                          className="w-5 h-5 mr-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                          ></path>
                        </svg>
                        Print/Download
                      </button>
                    )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {showPdfPreview && (
        <PDFContent
          formData={formData}
          filePreviews={filePreviews}
          isEdit={isEdit}
          selectedRoom={selectedRoom}
          guestPreviewUrls={guestPreviewUrls}
          showPreview={showPdfPreview}
          setShowPdfPreview={setShowPdfPreview}
        />
      )}

      {showFullScreenSign && (
        <FullScreenSignatureModal
          showFullScreenSign={showFullScreenSign}
          activeGuestIndex={activeGuestIndex}
          fullScreenSigCanvas={fullScreenSigCanvas}
          signErr={signErr}
          setsignErr={setsignErr}
          handleFullScreenSave={handleFullScreenSave}
        />
      )}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center transition-opacity z-50 p-4"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="relative max-w-full max-h-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage}
              alt="Enlarged preview"
              className="max-w-[90vw] max-h-[90vh] object-contain"
            />
          </div>
        </div>
      )}

      {showCancelModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-0">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            onClick={() => setShowCancelModal(false)}
          ></div>

          {/* Modal container */}
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                {/* Icon */}
                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                  <svg
                    className="h-6 w-6 text-blue-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                    />
                  </svg>
                </div>

                {/* Content */}
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    Close Without Saving?
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Your changes haven't been saved yet. Are you sure you want
                      to close this?
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Action buttons */}
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={handlecancel}
                className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
              >
                <svg
                  className="-ml-1 mr-2 h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                Confirm Close
              </button>
              <button
                type="button"
                onClick={() => setShowCancelModal(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >
                <svg
                  className="-ml-1 mr-2 h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showSubmitConfirmModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-0">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            onClick={() => setShowSubmitConfirmModal(false)}
          ></div>

          {/* Modal container */}
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                {/* Icon - Different colors for edit vs submit */}
                <div
                  className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10`}
                >
                  <svg
                    className={`h-6 w-6 text-green-600`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    {isEdit ? (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    ) : (
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    )}
                  </svg>
                </div>

                {/* Content */}
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    {isEdit ? "Update Form?" : "Submit Form?"}
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {isEdit
                        ? "Are you sure you want to update this form? Your changes will be saved."
                        : "Are you sure you want to submit this form? This action cannot be undone."}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Action buttons */}
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                disabled={isLoading}
                onClick={() => {
                  if (!isLoading) {
                    setIsLoading(true);
                    handleSubmit();
                  }
                }}
                className={`inline-flex items-center w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none sm:ml-3 sm:w-auto sm:text-sm bg-green-600 hover:bg-green-700
          }`}
              >
                {isLoading ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    {isEdit ? "Updating..." : "Submitting..."}
                  </>
                ) : (
                  <>
                    <svg
                      className="-ml-1 mr-2 h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      {isEdit ? (
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      ) : (
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      )}
                    </svg>
                    {isEdit ? "Confirm Update" : "Confirm Submit"}
                  </>
                )}
              </button>
              <button
                type="button"
                onClick={() => setShowSubmitConfirmModal(false)}
                className="mt-3 inline-flex items-center w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              >
                <svg
                  className="-ml-1 mr-2 h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GuestAndCheckInForm;
